import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="modal-2"
export default class extends Controller {
	static targets = ["backdrop", "panel", "content", "modal", "show"]

	static values = {
		open: false,
		defaultContent: `<turbo-frame id="modal_2"><div class="flex items-center justify-center h-full"><svg width="100px" height="100px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="icons" style=""><circle cx="50" cy="50" fill="none" ng-attr-stroke="{{config.color}}" ng-attr-stroke-width="{{config.width}}" ng-attr-r="{{config.radius}}" ng-attr-stroke-dasharray="{{config.dasharray}}" stroke="#999999" stroke-width="4" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(335.771 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg></div></turbo-frame>`,
	}

	connect() {
		if (this.hasContentTarget) this.contentTarget.innerHTML = this.defaultContentValue
	}

	open() {
		if (this.openValue) return

		this.modalTarget.classList.remove("hidden")
		enter(this.backdropTarget)
		enter(this.panelTarget)
		this.openValue = true
	}

	close() {
		if (!this.openValue) return

		this.openValue = false
		Promise.all([leave(this.backdropTarget), leave(this.panelTarget)]).then(() => {
			this.modalTarget.classList.add("hidden")
			if (this.hasContentTarget) this.contentTarget.innerHTML = this.defaultContentValue
		})
	}

	showTargetConnected() {
		this.open()
	}
}
